<script setup>
import { parseHeziyunData } from '@/utils/heziyunData' // 解析数据


const HeziyunData = ref(parseHeziyunData().global)

console.log(HeziyunData.value)

import consultingService from '@/components/main/consultingService.vue'


const consultModalRef = ref(null)

const openConsultModal = () => {
    if (consultModalRef.value) {
        consultModalRef.value.handleClick()
    }
}

</script>

<template>
    <!-- banner图 -->
    <div class="Heziyun-banners">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-banner-title">
                <h1 v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('agent.bannerTitle') }}</h1>
                <p v-intersect="{ class: 'bottom-top', delay: 200 }">{{ $t('agent.bannerSubtitle') }}
                </p>
                <div class="Heziyun-buttonArray" v-intersect="{ class: 'bottom-top', delay: 300 }">
                    <a href="/home.htm">{{ $t('agent.bannerButton') }}</a>
                </div>
            </div>
        </div>
    </div>

    <!-- 开放产品能力 -->
    <div class="Heziyun-open-product Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('agent.openProductAbility')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }"></p>
            </div>
            <div class="Heziyun-capacity">
                <div class="Heziyun-itemAbility" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <img src="@/static/img/agent/itemAbility1.png" alt="">
                    <span>{{ $t('agent.product1Title') }}</span>
                    <p>{{ $t('agent.product1Desc') }}</p>
                </div>
                <div class="Heziyun-itemAbility" v-intersect="{ class: 'bottom-top', delay: 300 }">
                    <img src="@/static/img/agent/itemAbility2.png" alt="">
                    <span>{{ $t('agent.product2Title') }}</span>
                    <p>{{ $t('agent.product2Desc') }}</p>
                </div>
                <div class="Heziyun-itemAbility" v-intersect="{ class: 'bottom-top', delay: 400 }">
                    <img src="@/static/img/agent/itemAbility3.png" alt="">
                    <span>{{ $t('agent.product3Title') }}</span>
                    <p>{{ $t('agent.product3Desc') }}</p>
                </div>
                <div class="Heziyun-itemAbility" v-intersect="{ class: 'bottom-top', delay: 500 }">
                    <img src="@/static/img/agent/itemAbility4.png" alt="">
                    <span>{{ $t('agent.product4Title') }}</span>
                    <p>{{ $t('agent.product4Desc') }}</p>
                </div>
                <div class="Heziyun-itemAbility" v-intersect="{ class: 'bottom-top', delay: 600 }">
                    <img src="@/static/img/agent/itemAbility5.png" alt="">
                    <span>{{ $t('agent.product5Title') }}</span>
                    <p>{{ $t('agent.product5Desc') }}</p>
                </div>
                <div class="Heziyun-itemAbility" v-intersect="{ class: 'bottom-top', delay: 700 }">
                    <img src="@/static/img/agent/itemAbility6.png" alt="">
                    <span>{{ $t('agent.product6Title') }}</span>
                    <p>{{ $t('agent.product6Desc') }}</p>
                </div>
                <div class="Heziyun-itemAbility" v-intersect="{ class: 'bottom-top', delay: 800 }">
                    <img src="@/static/img/agent/itemAbility7.png" alt="">
                    <span>{{ $t('agent.product7Title') }}</span>
                    <p>{{ $t('agent.product7Desc') }}</p>
                </div>
                <div class="Heziyun-itemAbility" v-intersect="{ class: 'bottom-top', delay: 900 }">
                    <img src="@/static/img/agent/itemAbility8.png" alt="">
                    <span>{{ $t('agent.product8Title') }}</span>
                    <p>{{ $t('agent.product8Desc') }}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- 合作优势 -->
    <div class="Heziyun-cooperation-advantage Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{
                    $t('agent.cooperationAdvantage') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }"></p>
            </div>
            <div class="Heziyun-cooperation">
                <div class="Heziyun-itemSolid" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <img src="@/static/img/agent/itemSolid4.png" alt="">
                    <span>{{ $t('agent.advantage1Title') }}</span>
                    <p>{{ $t('agent.advantage1Desc') }}</p>
                </div>
                <div class="Heziyun-itemSolid" v-intersect="{ class: 'bottom-top', delay: 300 }">
                    <img src="@/static/img/agent/itemSolid2.png" alt="">
                    <span>{{ $t('agent.advantage2Title') }}</span>
                    <p>{{ $t('agent.advantage2Desc') }}</p>
                </div>
                <div class="Heziyun-itemSolid" v-intersect="{ class: 'bottom-top', delay: 400 }">
                    <img src="@/static/img/agent/itemSolid3.png" alt="">
                    <span>{{ $t('agent.advantage3Title') }}</span>
                    <p>{{ $t('agent.advantage3Desc') }}</p>
                </div>
                <div class="Heziyun-itemSolid" v-intersect="{ class: 'bottom-top', delay: 400 }">
                    <img src="@/static/img/agent/itemSolid1.png" alt="">
                    <span>{{ $t('agent.advantage4Title') }}</span>
                    <p>{{ $t('agent.advantage4Desc') }}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- 合作流程 -->
    <div class="Heziyun-cooperation-process Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('agent.cooperationProcess')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }"></p>
            </div>
            <div class="Heziyun-technologicalProcess">
                <div class="Heziyun-itemFlow" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <div class="Heziyun-farAway"><img src="@/static/img/agent/itemFlow1.svg" alt="">
                    </div>
                    <span>{{ $t('agent.process1Title') }}</span>
                    <p>{{ $t('agent.process1Desc') }}</p>
                </div>
                <div class="Heziyun-itemFlow" v-intersect="{ class: 'bottom-top', delay: 300 }">
                    <div class="Heziyun-farAway"><img src="@/static/img/agent/itemFlow2.svg" alt="">
                    </div>
                    <span>{{ $t('agent.process2Title') }}</span>
                    <p>{{ $t('agent.process2Desc') }}</p>
                </div>
                <div class="Heziyun-itemFlow" v-intersect="{ class: 'bottom-top', delay: 400 }">
                    <div class="Heziyun-farAway"><img src="@/static/img/agent/itemFlow3.svg" alt="">
                    </div>
                    <span>{{ $t('agent.process3Title') }}</span>
                    <p>{{ $t('agent.process3Desc') }}</p>
                </div>
                <div class="Heziyun-itemFlow" v-intersect="{ class: 'bottom-top', delay: 500 }">
                    <div class="Heziyun-farAway"><img src="@/static/img/agent/itemFlow4.svg" alt="">
                    </div>
                    <span>{{ $t('agent.process4Title') }}</span>
                    <p>{{ $t('agent.process4Desc') }}</p>
                </div>
                <div class="Heziyun-itemFlow" v-intersect="{ class: 'bottom-top', delay: 600 }">
                    <div class="Heziyun-farAway"><img src="@/static/img/agent/itemFlow5.svg" alt="">
                    </div>
                    <span>{{ $t('agent.process5Title') }}</span>
                    <p>{{ $t('agent.process5Desc') }}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- 合作支持 -->
    <div class="Heziyun-cooperation-support Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('agent.cooperationSupport')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }"></p>
            </div>
            <div class="Heziyun-cooperation">
                <div class="Heziyun-itemSupport" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <div class="Heziyun-move">
                        <img src="@/static/img/agent/itemSupport1.png" alt="">
                        <span>{{ $t('agent.support1Title') }}</span>
                        <div class="Heziyun-translation">{{ $t('agent.support1EnTitle') }}</div>
                        <p>{{ $t('agent.support1Desc') }}</p>
                    </div>
                    <button @click="openConsultModal">{{ $t('agent.contactUs') }}</button>
                </div>
                <div class="Heziyun-itemSupport" v-intersect="{ class: 'bottom-top', delay: 300 }">
                    <div class="Heziyun-move">
                        <img src="@/static/img/agent/itemSupport2.png" alt="">
                        <span>{{ $t('agent.support2Title') }}</span>
                        <div class="Heziyun-translation">{{ $t('agent.support2EnTitle') }}</div>
                        <p>{{ $t('agent.support2Desc') }}</p>
                    </div>
                    <button @click="openConsultModal">{{ $t('agent.contactUs') }}</button>
                </div>
                <div class="Heziyun-itemSupport" v-intersect="{ class: 'bottom-top', delay: 400 }">
                    <div class="Heziyun-move">
                        <img src="@/static/img/agent/itemSupport3.png" alt="">
                        <span>{{ $t('agent.support3Title') }}</span>
                        <div class="Heziyun-translation">{{ $t('agent.support3EnTitle') }}</div>
                        <p>{{ $t('agent.support3Desc') }}</p>
                    </div>
                    <button @click="openConsultModal">{{ $t('agent.contactUs') }}</button>
                </div>
                <div class="Heziyun-itemSupport" v-intersect="{ class: 'bottom-top', delay: 500 }">
                    <div class="Heziyun-move">
                        <img src="@/static/img/agent/itemSupport4.png" alt="">
                        <span>{{ $t('agent.support4Title') }}</span>
                        <div class="Heziyun-translation">{{ $t('agent.support4EnTitle') }}</div>
                        <p>{{ $t('agent.support4Desc') }}</p>
                    </div>
                    <button @click="openConsultModal">{{ $t('agent.contactUs') }}</button>
                </div>
                <div class="Heziyun-itemSupport" v-intersect="{ class: 'bottom-top', delay: 600 }">
                    <div class="Heziyun-move">
                        <img src="@/static/img/agent/itemSupport5.png" alt="">
                        <span>{{ $t('agent.support5Title') }}</span>
                        <div class="Heziyun-translation">{{ $t('agent.support5EnTitle') }}</div>
                        <p>{{ $t('agent.support5Desc') }}</p>
                    </div>
                    <button @click="openConsultModal">{{ $t('agent.contactUs') }}</button>
                </div>
                <div class="Heziyun-itemSupport" v-intersect="{ class: 'bottom-top', delay: 700 }">
                    <div class="Heziyun-move">
                        <img src="@/static/img/agent/itemSupport6.png" alt="">
                        <span>{{ $t('agent.support6Title') }}</span>
                        <div class="Heziyun-translation">{{ $t('agent.support6EnTitle') }}</div>
                        <p>{{ $t('agent.support6Desc') }}</p>
                    </div>
                    <button @click="openConsultModal">{{ $t('agent.contactUs') }}</button>
                </div>
                <div class="Heziyun-itemSupport" v-intersect="{ class: 'bottom-top', delay: 800 }">
                    <div class="Heziyun-move">
                        <img src="@/static/img/agent/itemSupport7.png" alt="">
                        <span>{{ $t('agent.support7Title') }}</span>
                        <div class="Heziyun-translation">{{ $t('agent.support7EnTitle') }}</div>
                        <p>{{ $t('agent.support7Desc') }}</p>
                    </div>
                    <button @click="openConsultModal">{{ $t('agent.contactUs') }}</button>
                </div>
                <div class="Heziyun-itemSupport" v-intersect="{ class: 'bottom-top', delay: 900 }">
                    <div class="Heziyun-move">
                        <img src="@/static/img/agent/itemSupport8.png" alt="">
                        <span>{{ $t('agent.support8Title') }}</span>
                        <div class="Heziyun-translation">{{ $t('agent.support8EnTitle') }}</div>
                        <p>{{ $t('agent.support8Desc') }}</p>
                    </div>
                    <button @click="openConsultModal">{{ $t('agent.contactUs') }}</button>
                </div>
            </div>
        </div>
    </div>

    <!-- 合作条件 -->
    <div class="Heziyun-cooperation-condition Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{
                    $t('agent.cooperationCondition') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }"></p>
            </div>
            <div class="Heziyun-condition">
                <div class="Heziyun-itemCondition" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <img src="@/static/img/agent/itemCondition1.png" alt="">
                    <span>{{ $t('agent.condition1Title') }}</span>
                    <p>{{ $t('agent.condition1Desc') }}</p>
                </div>
                <div class="Heziyun-itemCondition" v-intersect="{ class: 'bottom-top', delay: 300 }">
                    <img src="@/static/img/agent/itemCondition2.png" alt="">
                    <span>{{ $t('agent.condition2Title') }}</span>
                    <p>{{ $t('agent.condition2Desc') }}</p>
                </div>
                <div class="Heziyun-itemCondition" v-intersect="{ class: 'bottom-top', delay: 400 }">
                    <img src="@/static/img/agent/itemCondition3.png" alt="">
                    <span>{{ $t('agent.condition3Title') }}</span>
                    <p>{{ $t('agent.condition3Desc') }}</p>
                </div>
                <div class="Heziyun-itemCondition" v-intersect="{ class: 'bottom-top', delay: 500 }">
                    <img src="@/static/img/agent/itemCondition4.png" alt="">
                    <span>{{ $t('agent.condition4Title') }}</span>
                    <p>{{ $t('agent.condition4Desc') }}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- 常见问题 -->
    <div class="Heziyun-commonProblem Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('agent.faqTitle') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }"></p>
            </div>
            <div class="Heziyun-problem">
                <div class="Heziyun-itemProblem" style="height: auto;"
                    v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <a-collapse :default-active-key="[1]" accordion expand-icon-position="left">
                        <template #expand-icon="{ active }">
                            <icon-minus-circle v-if="active" />
                            <icon-plus-circle v-else />
                        </template>

                        <a-collapse-item :header="$t('agent.faq1Question')" key="1">
                            <div class="Heziyun-assemble">
                                <p>
                                    <img src="@/static/img/agent/checkMark.svg" alt="步骤一">
                                    {{ $t('agent.faq1Step1') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark.svg" alt="步骤二">
                                    {{ $t('agent.faq1Step2') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark.svg" alt="步骤三">
                                    {{ $t('agent.faq1Step3') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark.svg" alt="步骤四">
                                    {{ $t('agent.faq1Step4') }}
                                </p>
                            </div>
                        </a-collapse-item>

                        <a-collapse-item :header="$t('agent.faq2Question')" key="2">
                            <div class="Heziyun-assemble">
                                <p>
                                    <img src="@/static/img/agent/checkMark2.svg" alt="资质一">
                                    {{ $t('agent.faq2Requirement1') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark3.svg" alt="资质二">
                                    {{ $t('agent.faq2Requirement2') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark4.svg" alt="资质三">
                                    {{ $t('agent.faq2Requirement3') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark4.svg" alt="资质四">
                                    {{ $t('agent.faq2Requirement4') }}
                                </p>
                            </div>
                        </a-collapse-item>

                        <a-collapse-item :header="$t('agent.faq3Question')" key="3">
                            <div class="Heziyun-assembleGrid">
                                <p>
                                    <img src="@/static/img/agent/checkMark5.svg" alt="云服务器">
                                    {{ $t('agent.faq3Product1') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark6.svg" alt="云数据库">
                                    {{ $t('agent.faq3Product2') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark7.svg" alt="云安全">
                                    {{ $t('agent.faq3Product3') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark8.svg" alt="网络服务">
                                    {{ $t('agent.faq3Product4') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark9.svg" alt="云存储">
                                    {{ $t('agent.faq3Product5') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark10.svg" alt="解决方案">
                                    {{ $t('agent.faq3Product6') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark10.svg" alt="容器服务">
                                    {{ $t('agent.faq3Product7') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark10.svg" alt="IDC服务">
                                    {{ $t('agent.faq3Product8') }}
                                </p>
                            </div>
                        </a-collapse-item>

                        <a-collapse-item :header="$t('agent.faq4Question')" key="4">
                            <div class="Heziyun-column">
                                <p>
                                    <span>{{ $t('agent.faq4Plan1Title') }}</span>
                                    {{ $t('agent.faq4Plan1Desc') }}
                                </p>
                                <p>
                                    <span>{{ $t('agent.faq4Plan2Title') }}</span>
                                    {{ $t('agent.faq4Plan2Desc') }}
                                </p>
                                <p>
                                    <span>{{ $t('agent.faq4Plan3Title') }}</span>
                                    {{ $t('agent.faq4Plan3Desc') }}
                                </p>
                                <p>
                                    <span>{{ $t('agent.faq4Plan4Title') }}</span>
                                    {{ $t('agent.faq4Plan4Desc') }}
                                </p>
                            </div>
                        </a-collapse-item>

                        <a-collapse-item :header="$t('agent.faq5Question')" key="5">
                            <div class="Heziyun-assemble">
                                <p>
                                    <img src="@/static/img/agent/checkMark.svg" alt="技术一">
                                    {{ $t('agent.faq5Support1') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark.svg" alt="技术二">
                                    {{ $t('agent.faq5Support2') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark.svg" alt="技术三">
                                    {{ $t('agent.faq5Support3') }}
                                </p>
                                <p>
                                    <img src="@/static/img/agent/checkMark.svg" alt="技术四">
                                    {{ $t('agent.faq5Support4') }}
                                </p>
                            </div>
                        </a-collapse-item>

                        <a-collapse-item :header="$t('agent.faq6Question')" key="6">
                            <div class="Heziyun-column">
                                <p>
                                    <span>{{ $t('agent.faq6Policy1Title') }}</span>
                                    {{ $t('agent.faq6Policy1Desc') }}
                                </p>
                                <p>
                                    <span>{{ $t('agent.faq6Policy2Title') }}</span>
                                    {{ $t('agent.faq6Policy2Desc') }}
                                </p>
                                <p>
                                    <span>{{ $t('agent.faq6Policy3Title') }}</span>
                                    {{ $t('agent.faq6Policy3Desc') }}
                                </p>
                                <p>
                                    <span>{{ $t('agent.faq6Policy4Title') }}</span>
                                    {{ $t('agent.faq6Policy4Desc') }}
                                </p>
                            </div>
                        </a-collapse-item>
                    </a-collapse>
                </div>
            </div>
        </div>
    </div>

    <!-- 联系我们咨询 -->
    <consultingService ref="consultModalRef"></consultingService>
</template>

<style>
@import "@/static/css/import";
@import "@/static/css/color.css";
@import "@/static/font/font.css";
</style>

<style lang="less" scoped>
:deep(.arco-collapse) {
    border: none;
}

:deep(.arco-collapse-item-header) {
    background-color: transparent;
    font-size: 16px;
    padding-top: 13px;
    padding-bottom: 13px;
}

:deep(.arco-collapse-item-active > .arco-collapse-item-header) {
    background-color: #d9d9d9;
}

:deep(.arco-collapse-item-content) {
    padding-left: 13px;
}


// banner图
.Heziyun-banners {
    background: url('@/static/img/agent/banner.webp') no-repeat right;
    background-size: cover;
    position: relative;
    height: 25rem;
    margin-top: 3.6rem;


    .Heziyun-defaultWidth {
        position: relative;
        z-index: 2;
        height: 100%;

        .Heziyun-banner-title {
            align-items: center;

            h1 {
                color: #fff;
                margin: 0;
                font-size: 2rem;
            }

            p {
                text-align: center;
                color: #fff;
            }
        }
    }

}

// 开放产品能力
.Heziyun-open-product {

    .Heziyun-defaultWidth {
        .Heziyun-capacity {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 1rem;

            .Heziyun-itemAbility {
                background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), rgba(255, 255, 255, 0.8);
                border: 0.06rem solid #E6F0FF;
                backdrop-filter: blur(0.75rem);
                box-shadow: 0rem 0.5rem 1rem 0rem rgb(116 116 116 / 5%);
                border-radius: 0.5rem;
                padding: 1rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 0.7rem;
                cursor: pointer;

                &:hover {
                    border: 1px solid #2c7ef9;

                    img {
                        transform: scale(1.3);
                    }
                }

                img {
                    width: 2.3rem;
                    height: 2.3rem;
                    object-fit: contain;
                }

                span {
                    color: #1F2937;
                    font-size: 1rem;
                }

                p {
                    color: #4B5563;
                    line-height: 1.7;
                    text-align: center;
                }
            }
        }
    }
}

// 合作优势
.Heziyun-cooperation-advantage {
    background: #363636;

    .Heziyun-defaultWidth {
        .Heziyun-commodity-title {
            span {
                color: #fff;
            }
        }

        .Heziyun-cooperation {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 1.5rem;

            .Heziyun-itemSolid {
                padding: 2rem;
                background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), rgba(255, 255, 255, 1);
                backdrop-filter: blur(0.63rem);
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 1.5rem;
                box-shadow: 0 10px 20px rgba(77, 77, 77, 0.05);

                img {
                    width: 3rem;
                    height: 3rem;
                }

                span {
                    color: #000;
                    font-weight: bold;
                    font-size: 1.1rem;
                }

                p {
                    color: #4B5563;
                    line-height: 1.5rem;
                    text-align: center;
                }
            }
        }
    }
}

// 合作流程
.Heziyun-cooperation-process {
    background: url('@/static/img/agent/bg_top@2x.webp') no-repeat center;
    background-size: cover;
    mask-image: linear-gradient(to bottom, black 0%, black 75%, transparent 100%);

    .Heziyun-defaultWidth {
        .Heziyun-technologicalProcess {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            gap: 2rem;

            .Heziyun-itemFlow {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 1rem;
                position: relative;

                .Heziyun-farAway {
                    background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), #FFFFFF;
                    border: 0.13rem solid #2563EB;
                    box-shadow: 0rem 0.25rem 0.38rem -0.25rem rgba(0, 0, 0, 0.1), 0rem 0.63rem 0.94rem -0.19rem rgba(0, 0, 0, 0.1);
                    padding: 0.9rem;
                    width: 3.5rem;
                    height: 3.5rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 1rem;
                    -webkit-border-radius: 1rem;
                    -moz-border-radius: 1rem;
                    -ms-border-radius: 1rem;
                    -o-border-radius: 1rem;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                span {
                    font-size: 1rem;
                    font-weight: bold;
                    margin-top: 0.5rem;
                }

                p {
                    color: #4B5563;
                    font-size: 0.85rem;
                    line-height: 1.5rem;
                    text-align: center;
                }
            }

            .Heziyun-itemFlow:nth-of-type(1) .Heziyun-farAway {
                background-color: #2563EB;
            }

            .Heziyun-itemFlow:not(:last-child)::after {
                content: "";
                position: absolute;
                top: 4rem;
                left: 11.5rem;
                width: 50%;
                height: 0.1rem;
                background: #E2E8F0;
            }
        }
    }
}

// 合作支持
.Heziyun-cooperation-support {
    background: #fff;

    .Heziyun-defaultWidth {
        .Heziyun-cooperation {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            gap: 1rem;

            .Heziyun-itemSupport {
                background: #fff;
                backdrop-filter: blur(0.63rem);
                padding: 3rem 1rem;
                border: 0.06rem solid #E6F0FF;
                border-radius: 0.5rem;
                height: 17rem;
                position: relative;

                &:hover {
                    border: 1px solid #CDDEFF;
                    background: linear-gradient(180deg, #F8FBFF 0%, #FFFFFF 100%);
                    box-shadow: 0 20px 15px 0 rgb(0 83 253 / 4%);

                    .Heziyun-move {
                        transform: translateY(-5rem);

                        p {
                            opacity: 1;
                        }
                    }

                    button {
                        visibility: inherit;
                        opacity: 1;
                    }
                }

                .Heziyun-move {
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    img {
                        width: 3.2rem;
                        height: 3.2rem;
                        object-fit: contain;
                        margin-bottom: 0.5rem;
                    }

                    span {
                        font-weight: bold;
                        font-size: 0.95rem;
                        text-align: center;
                        line-height: 1.7;
                        margin-bottom: 0.5rem;
                        color: #333333;
                    }

                    p {
                        color: #0061ea;
                        text-align: center;
                        line-height: 1.5rem;
                        opacity: 0;
                        margin-top: 0.5rem;
                    }
                }

                button {
                    background-color: #0061ea;
                    color: #fff;
                    border: none;
                    position: absolute;
                    width: 100%;
                    height: 2rem;
                    bottom: 0;
                    left: 0;
                    border-radius: 0 0 0.5rem 0.5rem;
                    cursor: pointer;
                    visibility: hidden;
                    opacity: 0;

                    &:hover {
                        background-color: #3f8cfa;
                    }
                }
            }
        }
    }
}

// 合作条件
.Heziyun-cooperation-condition {
    background: url('@/static/img/agent/footer-content-bg.webp') no-repeat center;
    background-size: cover;

    .Heziyun-defaultWidth {

        .Heziyun-commodity-title {
            span {
                color: #fff;
            }
        }

        .Heziyun-condition {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 1.5rem;

            .Heziyun-itemCondition {
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
                padding: 1.5rem;
                border-radius: 1rem;
                -webkit-border-radius: 1rem;
                -moz-border-radius: 1rem;
                -ms-border-radius: 1rem;
                -o-border-radius: 1rem;
                background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), rgba(255, 255, 255, 0.05);
                border: 0.06rem solid rgba(255, 255, 255, 0.1);
                backdrop-filter: blur(0.63rem);
                position: relative;
                overflow: hidden;
                border-top: 0.15rem solid transparent;
                border-bottom: 0.15rem solid transparent;
                border: 1px solid transparent;

                img {
                    width: 3rem;
                    height: 3rem;

                }

                span {
                    color: #fff;
                    font-size: 1rem;
                    font-weight: bold;
                }

                p {
                    color: #D1D5DB;
                    line-height: 1.5rem;
                    font-size: 0.85rem;
                }
            }
        }
    }
}

// 常见问题
.Heziyun-commonProblem {
    background: #F9FAFB;

    .Heziyun-defaultWidth {
        .Heziyun-problem {
            display: flex;
            flex-direction: column;
            gap: 1rem;

            .Heziyun-itemProblem {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                height: 5rem;
                overflow: hidden;
                padding: 0 5rem;

                .Heziyun-titles {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 1rem;

                    span {
                        color: #1F2937;
                        font-weight: bold;
                        font-size: 1rem;
                    }

                    .Heziyun-event {
                        width: 1rem;
                        height: 1rem;
                        cursor: pointer;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .Heziyun-assemble {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;

                    p {
                        display: flex;
                        align-items: center;
                        gap: 0.4rem;
                        color: #4B5563;
                        font-size: 0.85rem;

                        img {
                            width: 0.8rem;
                            height: 0.8rem;
                        }
                    }
                }

                .Heziyun-assembleGrid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 0.5rem;

                    p {
                        background: #f2f2f2;
                        display: flex;
                        align-items: center;
                        gap: 0.3rem;
                        padding: 0.5rem 1rem;
                        border-radius: 0.3rem;
                        color: #4B5563;
                        font-size: 0.85rem;

                        img {
                            width: 0.8rem;
                            height: 0.8rem;
                        }
                    }
                }

                .Heziyun-column {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;

                    p {
                        color: #4B5563;
                        background: #f2f2f2;
                        padding: 0.5rem 1rem;
                        border-radius: 0.2rem;
                        display: flex;
                        flex-direction: column;
                        gap: 0.1rem;

                        span {
                            color: #1F2937;
                            font-size: 0.9rem;
                        }
                    }
                }

            }
        }
    }
}

@media (max-width: 768px) {

    // banner图
    .Heziyun-banners {
        height: 70vw;
        margin-top: 15vw;
        padding: 0;

        .Heziyun-defaultWidth {
            .Heziyun-banner-title {

                h1 {
                    font-size: 6vw;
                }

                p {
                    text-align: center;
                    color: #fff;
                }

                .Heziyun-buttonArray {
                    a {}
                }
            }
        }
    }

    // 开放产品能力
    .Heziyun-open-product {

        .Heziyun-defaultWidth {
            .Heziyun-capacity {
                grid-template-columns: repeat(1, 1fr);
                gap: 4vw;

                .Heziyun-itemAbility {
                    border-radius: 2vw;
                    -webkit-border-radius: 2vw;
                    -moz-border-radius: 2vw;
                    -ms-border-radius: 2vw;
                    -o-border-radius: 2vw;
                    padding: 3vw;
                    gap: 3vw;

                    img {
                        width: 10vw;
                        height: 10vw;
                    }

                    span {
                        font-size: 4.5vw;
                    }

                    p {
                        line-height: 6vw;
                        font-size: 3.5vw;
                    }
                }
            }
        }
    }

    // 合作优势
    .Heziyun-cooperation-advantage {

        .Heziyun-defaultWidth {
            .Heziyun-cooperation {
                grid-template-columns: repeat(1, 1fr);
                gap: 3vw;

                .Heziyun-itemSolid {
                    padding: 4vw;
                    border-radius: 1vw;
                    -webkit-border-radius: 1vw;
                    -moz-border-radius: 1vw;
                    -ms-border-radius: 1vw;
                    -o-border-radius: 1vw;
                    gap: 3vw;

                    img {
                        width: 11vw;
                        height: 11vw;
                    }

                    span {
                        font-size: 4.5vw;
                    }

                    p {
                        line-height: 6vw;
                        font-size: 3.5vw;
                    }
                }
            }
        }
    }

    // 合作流程
    .Heziyun-cooperation-process {
        padding-bottom: 20vw;

        .Heziyun-defaultWidth {
            .Heziyun-technologicalProcess {
                grid-template-columns: repeat(1, 1fr);
                gap: 8vw;

                .Heziyun-itemFlow {
                    gap: 2vw;

                    .Heziyun-farAway {
                        padding: 2vw;
                        width: 10vw;
                        height: 10vw;
                        border-radius: 2vw;
                        -webkit-border-radius: 2vw;
                        -moz-border-radius: 2vw;
                        -ms-border-radius: 2vw;
                        -o-border-radius: 2vw;
                    }

                    span {
                        font-size: 4.5vw;
                        font-weight: bold;
                        margin-top: 2vw;
                    }

                    p {
                        font-size: 3.5vw;
                        line-height: 6vw;
                    }
                }

                .Heziyun-itemFlow:not(:last-child)::after {
                    top: 30vw;
                    left: 45vw;
                    width: 0.5vw;
                    height: 5vw;
                }
            }
        }
    }

    // 合作支持
    .Heziyun-cooperation-support {
        .Heziyun-defaultWidth {
            .Heziyun-cooperation {
                grid-template-columns: repeat(1, 1fr);
                gap: 5vw;

                .Heziyun-itemSupport {
                    padding: 4vw;
                    height: 50vw;

                    &:hover {
                        .Heziyun-move {
                            transform: translateY(-25%);
                        }
                    }

                    .Heziyun-move {
                        gap: 1vw;

                        img {
                            width: 10vw;
                            height: 10vw;
                        }

                        span {
                            font-size: 4vw;
                        }

                        p {
                            font-size: 3.5vw;
                            line-height: 6vw;
                            opacity: 1;
                        }
                    }

                    button {
                        height: 10vw;
                    }

                }
            }
        }
    }

    // 合作条件
    .Heziyun-cooperation-condition {
        .Heziyun-defaultWidth {

            .Heziyun-condition {
                grid-template-columns: repeat(1, 1fr);
                gap: 3vw;

                .Heziyun-itemCondition {
                    gap: 3vw;
                    padding: 4vw;
                    border-radius: 2vw;
                    -webkit-border-radius: 2vw;
                    -moz-border-radius: 2vw;
                    -ms-border-radius: 2vw;
                    -o-border-radius: 2vw;

                    img {
                        width: 11vw;
                        height: 11vw;
                    }

                    span {
                        font-size: 4.5vw;
                    }

                    p {
                        line-height: 6vw;
                        font-size: 3.5vw;
                    }
                }
            }
        }
    }

    // 常见问题
    .Heziyun-commonProblem {

        .Heziyun-defaultWidth {
            .Heziyun-problem {
                gap: 3vw;

                .Heziyun-itemProblem {
                    gap: 2vw;
                    padding: 0;
                    border-radius: 2vw;
                    -webkit-border-radius: 2vw;
                    -moz-border-radius: 2vw;
                    -ms-border-radius: 2vw;
                    -o-border-radius: 2vw;
                    height: 13vw;

                    .Heziyun-titles {
                        margin-bottom: 3vw;

                        span {
                            font-size: 4vw;
                        }

                        .Heziyun-event {
                            width: 4vw;
                            height: 4vw;
                        }
                    }

                    .Heziyun-assemble {
                        gap: 2vw;

                        p {
                            gap: 2vw;
                            font-size: 3.5vw;

                            img {
                                width: 3vw;
                                height: 3vw;
                            }
                        }
                    }

                    .Heziyun-assembleGrid {
                        gap: 1vw;
                        grid-template-columns: repeat(2, 1fr);

                        p {
                            gap: 1vw;
                            padding: 2vw;
                            border-radius: 1vw;
                            font-size: 3.5vw;
                            display: flex;
                            align-items: center;

                            img {
                                width: 3vw;
                                height: 3vw;
                            }
                        }
                    }

                    .Heziyun-column {
                        gap: 2vw;

                        p {
                            color: #4B5563;
                            padding: 2vw;
                            border-radius: 1vw;
                            -webkit-border-radius: 1vw;
                            -moz-border-radius: 1vw;
                            -ms-border-radius: 1vw;
                            -o-border-radius: 1vw;
                            gap: 1vw;
                            font-size: 3.5vw;

                            span {
                                font-size: 4vw;
                            }
                        }
                    }

                }
            }
        }
    }
}
</style>